import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ScrEnvironment } from 'src/environments/environment';
import { Card, AchPaymentMethod } from '../models/payment.model';
import { WITHCRED, WithCredNoCache } from './authentication.service';
import { IScrBaseResponse, ScrBaseService } from './base.service';
import { ScrServiceManager } from './servicemanager.service';

export interface PaymentMethodsListResponse extends IScrBaseResponse {
  creditcard?: Card[];
  ach?: AchPaymentMethod[];
}

export interface PaymentMethodAddResponse extends IScrBaseResponse {
  // either ach or cc is returned - caller knows which to expect.
  ach: AchPaymentMethod;
  cc: Card;
}

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodsService extends ScrBaseService {

  constructor(
    serviceManager: ScrServiceManager,
    private environment: ScrEnvironment,
    private http: HttpClient) {
    super(serviceManager);

  }

  retrievePaymentMethods(): Observable<PaymentMethodsListResponse> {
    const url = `${this.environment.base}/secure/paymentmethods`;
    return this.http.get<PaymentMethodsListResponse>(url, WithCredNoCache);
  }

  addCreditCard(json: Card): Observable<PaymentMethodAddResponse> {
    // Note: POST to paymentmethods is redirected in F5 to function URL
    const url = `${this.environment.base}/fct/paymentmethods`;
    const body = this.functionUrlBody('add', {'cc': json});
    return this.http.post<PaymentMethodAddResponse>(url, body, WITHCRED);
  }

  updateCreditCard(json: Card): Observable<IScrBaseResponse> {
    // Note: POST to paymentmethods is redirected in F5 to function URL
    const url = `${this.environment.base}/fct/paymentmethods`;
    const body = this.functionUrlBody('update', {'cc': json});
    return this.http.post<IScrBaseResponse>(url, body, WITHCRED);
  }

  removeCreditCard(creditCardId: number): Observable<IScrBaseResponse> {
    // Note: POST to paymentmethods is redirected in F5 to function URL
    const url = `${this.environment.base}/fct/paymentmethods`;
    const body = this.functionUrlBody('delete', {creditCardId:creditCardId});
    return this.http.post<IScrBaseResponse>(url, body, WITHCRED);
  }

 
  setAsDefaultCard(creditCardId: number): Observable<IScrBaseResponse> {
    // Note: POST to paymentmethods is redirected in F5 to function URL
    const url = `${this.environment.base}/fct/paymentmethods`;
    const body = this.functionUrlBody('setdefault', {creditCardId:creditCardId});
    return this.http.post<IScrBaseResponse>(url, body, WITHCRED);
  }

  addAchPaymentMethod(json: AchPaymentMethod): Observable<PaymentMethodAddResponse> {
    // Note: POST to paymentmethods is redirected in F5 to function URL
    const url = `${this.environment.base}/fct/paymentmethods`;
    const body = this.functionUrlBody('add', {'ach': json});
    return this.http.post<PaymentMethodAddResponse>(url, body, WITHCRED);
  }

  updateAchPaymentMethod(json: AchPaymentMethod): Observable<IScrBaseResponse> {
    // Note: POST to paymentmethods is redirected in F5 to function URL
    const url = `${this.environment.base}/fct/paymentmethods`;
    const body = this.functionUrlBody('update', {'ach': json});
    return this.http.post<IScrBaseResponse>(url, body, WITHCRED);
  }

  removeAchPaymentMethod(achPaymentMethodId: number): Observable<IScrBaseResponse> {
    // Note: POST to paymentmethods is redirected in F5 to function URL
    const url = `${this.environment.base}/fct/paymentmethods`;
    const body = this.functionUrlBody('delete', {achPaymentMethodId:achPaymentMethodId});
    return this.http.post<IScrBaseResponse>(url, body, WITHCRED);
  }


  setAsDefaultPaymentMethod(achPaymentMethodId: number): Observable<IScrBaseResponse> {
    // Note: POST to paymentmethods is redirected in F5 to function URL
    const url = `${this.environment.base}/fct/paymentmethods`;
    const body = this.functionUrlBody('setdefault', {achPaymentMethodId:achPaymentMethodId});
    return this.http.post<IScrBaseResponse>(url, body, WITHCRED);
  }
}
